import get from "lodash/get";
import type { Action } from "../../actions/types";

export type StoreState = {
  [key: string]: any;
};

export const initialState: StoreState = {};

export function reducer(state: StoreState = initialState, action: Action) {
  if (action.type === "CORS_REQUEST") {
    let customer;

    switch (get(action, "payload.type") || get(action, "fullPayload.type")) {
      case "purchase":
        customer = {
          ...state.customer,
          ...action.fullPayload.customer,
        };

        return {
          ...state,
          purchase: action.fullPayload,
          customer,
        };

      case "product":
        return {
          ...state,
          product: action.fullPayload,
        };

      case "email":
      case "email_capture":
      case "sign_up":
        customer = state.customer || {};

        return {
          ...state,
          customer: { ...customer, ...action.fullPayload },
        };

      case "page":
        return {
          ...state,
          page: action.fullPayload,
        };

      case "customer":
        return {
          ...state,
          customer: action.fullPayload,
        };

      default:
        return state;
    }
  }

  return state;
}
